<template>
  <v-app v-if="!loading" style="overflow-x: hidden!important;overflow-y:scroll!important;height: 100vh!important; ">
    <v-main v-if="!$store.state.loading">
      <div v-if="screenType === 'mobile' && showNavbar">
        <nav-bar-mobile :notifications="notifications"></nav-bar-mobile>
        <global-snack-bar-mobile class="snackbar-text"></global-snack-bar-mobile>
      </div>
      <div v-else-if="screenType === 'desktop' && showNavbar">
        <navbar-desktop :notifications="notifications"></navbar-desktop>
        <global-snack-bar-desktop class="snackbar-text"></global-snack-bar-desktop>
      </div>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import GlobalSnackBarDesktop from "@/components/Components/Desktop/Notification/GlobalSnackBarDesktop";
import NavbarDesktop from "@/components/Components/Desktop/Navbar/NavbarDesktop";
import NavBarMobile from "@/components/Components/Mobile/Navbar/NavbarMobile";
import GlobalSnackBarMobile from "@/components/Components/Mobile/Notification/GlobalSnackBarMobile";
import Echo from "laravel-echo";

export default {
  name: 'App',
  components: {GlobalSnackBarMobile, NavBarMobile, GlobalSnackBarDesktop, NavbarDesktop},
  watch: {
    $route(to, from) {
      this.trackActivity(to, from)
    }
  },
  data: () => ({
    screenType: null,
    loading: true,
    notifications: [],
    lastTrackedPath: null,
  }),
  computed: {
    showNavbar() {
      return !this.$route.path.includes('/dashboard/my-courses/dictation/show/') && !this.$route.path.startsWith('/social/share/');
    }
  },
  async mounted() {
    await this.getScreenType()
    await this.getProfile()
    this.getNotifications()
    this.initialWS()
    this.initialListenWs()
  },
  methods: {
    getScreenType() {
      this.screenType = window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    },
    async getProfile() {
      if (this.$store.state.user) {
        this.$store.state.user = null
      }
      await window.axios.get('student/profile/get').then((res) => {
        this.$store.state.user = res.data.data
        this.$store.state.auth = true
        this.$store.state.loading = false
        this.trackActivity(this.$route)
        if (this.$route.path === '/login' || this.$route.path === '/register') {
          this.$router.push('/dashboard')
        }
        this.loading = false
      }).catch(() => {
        if (
            this.$route.path !== '/' &&
            this.$route.path !== '/login' &&
            this.$route.path !== '/register' &&
            this.$route.path !== '/blog' &&
            this.$route.path !== '/contact-us' &&
            this.$route.path !== '/about-us'
            && !this.$route.path.startsWith('/social/share/')
        ) {
          this.$router.push('/login')
        }
        this.loading = false
      })
    },
    initialWS() {
      if (!this.$store.state.user) {
        return
      }
      this.$store.state.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'myKey',
        cluster: 'mt1',
        wsHost: process.env.VUE_APP_WS_HOST,
        wsPort: process.env.VUE_APP_WS_PORT,
        forceTLS: process.env.VUE_APP_FORCE_TLS !== 'false',
        disableStats: true,
        encrypted: true,
        auth: {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        },
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              window.mainAxios.post('/api/students/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
                  .then(response => {
                    callback(false, response.data);
                  })
                  .catch(error => {
                    callback(true, error);
                  });
            }
          };
        },
      });
      this.$store.state.loadingEcho = false
    },
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.notification.' + this.$store.state.user.id)
            .listen('SendNotification', () => {
              this.getNotifications()
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.notification.' + self.$store.state.user.id)
              .listen('SendNotification', () => {
                self.getNotifications()
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
    getNotifications() {
      window.axios.get('student/notification/index/unseen').then((res) => {
        this.notifications = res.data.data
      })
    },
    activityTitle(route) {
      const path = route?.path || ''
      if (path === '/dashboard') return 'ورود به داشبورد'
      if (path === '/dashboard/profile') return 'ورود به صفحه پروفایل'
      if (path === '/dashboard/my-courses') return 'ورود به دوره های من'
      if (path.startsWith('/dashboard/my-courses/lessons/')) return 'ورود به فهرست درس ها'
      if (path.startsWith('/dashboard/my-courses/item/')) return 'ورود به صفحه مشاهده درس'
      if (path.startsWith('/dashboard/my-courses/dictation/show/')) return 'ورود به صفحه دیکته'
      if (path === '/dashboard/online-sessions') return 'ورود به جلسات من'
      if (path.startsWith('/dashboard/sessions/')) return 'ورود به صفحه جلسه آنلاین'
      if (path === '/dashboard/assessments') return 'ورود به ارزیابی ها'
      if (path === '/dashboard/notifications') return 'ورود به اعلان ها'
      if (path === '/dashboard/transactions') return 'ورود به تراکنش ها'
      if (path === '/dashboard/subscriptions') return 'ورود به اشتراک ها'
      if (path === '/dashboard/courses') return 'ورود به دوره ها'
      if (path.startsWith('/dashboard/course/buy/')) return 'ورود به صفحه خرید دوره'
      return route?.meta?.activityTitleFa || route?.name || path || 'ورود به صفحه ناشناخته'
    },
    trackActivity(route = this.$route) {
      if (!this.$store.state.auth || !this.$store.state.user || !route) {
        return
      }
      if (route.path === '/login' || route.path === '/register') {
        return
      }
      if (route.path === this.lastTrackedPath) {
        return
      }
      this.lastTrackedPath = route.path
      window.axios.post('student/activity/track', {
        title_fa: this.activityTitle(route),
        route_name: route.name || null,
        route_path: route.path || null,
      }).catch(() => {})
    }
  }
}
</script>
<style>
@font-face {
  font-family: Vazir;
  src: url("../src/assets/fonts/vazir/Vazir.ttf");
}
@font-face {
  font-family: 'Roboto';
  src: url('../public/assets/fonts/roboto/Roboto-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
* {
  font-family: Vazir, Roboto;
}

.color-green {
  color: #1ab69d !important;
}

.button-normal-white {
  letter-spacing: normal !important;
  color: white !important;
}

.button-normal-black {
  letter-spacing: normal !important;
  color: black !important;
}
</style>
